import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export const removeAdditionalParentCategory = async (postId: string, parentCategoryId: string) => {
  const [response, bodyOrError] = await Api.post(`posts/${postId}/remove-parent`, {
    parentCategoryId,
  });
  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useRemoveAdditionalParentCategory = () => {
  const queryClient = useQueryClient();
  return useMutation(
    'removeAdditionalParentCategory',
    (data: { postId: string; parentCategoryId: string }) => {
      return removeAdditionalParentCategory(data.postId, data.parentCategoryId);
    },
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(['getPostById', variables.postId]);
      },
    },
  );
};
